import i18n from "@i18n/i18n";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { GridApi, GridFilterItem, gridFilterModelSelector } from "@mui/x-data-grid-premium";
import React, { useState } from "react";

type NullableBooleanColumnFilterProps = {
  apiRef: React.MutableRefObject<GridApi>;
  field: string;
  labels?: {
    none?: string;
    true?: string;
    false?: string;
  };
};

const NullableBooleanColumnFilter: React.FC<NullableBooleanColumnFilterProps> = ({ apiRef, field, labels = {} }) => {
  const [filterValue, setFilterValue] = useState<boolean | null>(null);

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;

    let parsedValue: boolean | null;
    if (value === "true") parsedValue = true;
    else if (value === "false") parsedValue = false;
    else parsedValue = null;

    setFilterValue(parsedValue);

    const newFilterModel = { ...gridFilterModelSelector(apiRef) };
    newFilterModel.items = newFilterModel.items.filter((item: GridFilterItem) => item.field !== field);
    if (parsedValue !== null) {
      newFilterModel.items.push({ id: 1 /* TODO: revisit this */, field: field, operator: "is", value: parsedValue });
    }
    apiRef.current.setFilterModel(newFilterModel);
  };

  const defaultLabels = {
    none: i18n.t("data-grid.nullable-boolean-filter.none"),
    true: i18n.t("data-grid.nullable-boolean-filter.true"),
    false: i18n.t("data-grid.nullable-boolean-filter.false"),
  };

  const mergedLabels = { ...defaultLabels, ...labels };

  return (
    <FormControl variant="standard" sx={{ m: 1 }} fullWidth>
      <InputLabel>Filter</InputLabel>
      <Select value={filterValue === null ? "" : String(filterValue)} onChange={handleChange}>
        <MenuItem value="">{mergedLabels.none}</MenuItem>
        <MenuItem value="true">{mergedLabels.true}</MenuItem>
        <MenuItem value="false">{mergedLabels.false}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default NullableBooleanColumnFilter;
